"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const mui_1 = require("tss-react/mui");
const react_redux_1 = require("react-redux");
const luxon_1 = require("luxon");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const material_1 = require("@mui/material");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const entitlements_1 = require("companion-app-components/flux/entitlements");
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  margin: 40px auto 5px;
  text-align: center;
`;
const Anchor = styled_components_1.default.a `
  display: inline-block;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
    color: inherit;
  }
`;
const FooterLinks = styled_components_1.default.div `
  color: ${({ theme }) => theme.palette.text.disabled};
`;
const useStyles = (0, mui_1.makeStyles)()(({ palette }) => ({
    caption: {
        color: palette.text.tertiary,
    },
}));
const Footer = ({ noWhiteSpace, textColor, isTablet }) => {
    const { classes } = useStyles();
    const { palette } = (0, material_1.useTheme)();
    const routeOptions = ({
        privacy: 'https://www.quicken.com/privacy/us',
        terms: 'https://www.quicken.com/terms-of-use',
        about: 'https://www.quicken.com/about-us',
        ccpa: 'https://www.quicken.com/privacy/us/ccpa/opt-out',
    });
    const featureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state));
    const showCcpa = featureFlags && featureFlags.get('ccpa');
    const isAuthenticated = (0, react_redux_1.useSelector)(entitlements_1.entitlementsSelectors.isAuthenticated);
    return (<Wrapper style={{
            margin: noWhiteSpace ? '0 auto' : '40px auto 5px',
            position: isTablet ? 'absolute' : 'relative',
            paddingBottom: isTablet ? '64px' : 'unset',
        }}>
      <FooterLinks>
        <Anchor target="_blank" id="Privacy_Policy_link" onmouseup={routeOptions.privacy} href={routeOptions.privacy}><Typography_1.default variant="caption" className={classes.caption} style={{ color: textColor || palette.text.tertiary }}>Privacy Policy</Typography_1.default></Anchor>&nbsp;|&nbsp;
        <Anchor target="_blank" id="Terms_of_Use_link" onmouseup={routeOptions.terms} href={routeOptions.terms}><Typography_1.default variant="caption" className={classes.caption} style={{ color: textColor || palette.text.tertiary }}>Terms of Use</Typography_1.default></Anchor>
        {showCcpa && (<>
            &nbsp;|&nbsp;
            <Anchor target="_blank" id="CCPA_link" onmouseup={routeOptions.ccpa} href={routeOptions.ccpa}>
              <Typography_1.default variant="caption" className={classes.caption} style={{ color: textColor || palette.text.tertiary }}>
                Do Not Sell My Personal Information
              </Typography_1.default>
            </Anchor>
          </>)}

        &nbsp;|&nbsp;
        <Anchor target="_blank" id="Acknowledgements" href="web-acknowledgements.txt">
          <Typography_1.default variant="caption" className={classes.caption} style={{ color: textColor || palette.text.tertiary }}>
            Acknowledgements
          </Typography_1.default>
        </Anchor>

        {' | '}
        {<Anchor target="_blank" id="About_Quicken_link" href={routeOptions.about}><Typography_1.default variant="caption" className={classes.caption} style={{ color: textColor || palette.text.tertiary }}>About Quicken</Typography_1.default></Anchor>}
        <br />
        <Typography_1.default variant="caption" className={classes.caption} style={{ color: textColor || palette.text.tertiary }}>&copy; Quicken Inc. All rights reserved. Quicken is a registered trademark of Rocket Mortgage, LLC, used under license.&nbsp;</Typography_1.default>
        <Typography_1.default variant="caption" className={classes.caption} style={{ color: textColor || palette.text.tertiary }}>
          Version: {process.env.APP_VERSION} ({process.env.BUILD_NUMBER}/{process.env.COMMIT})
          {(process.env.NODE_ENV !== 'production' || (process.env.SERVICE_ENV && process.env.SERVICE_ENV !== 'prod')) && (<>
              {` Built: ${luxon_1.DateTime.fromJSDate(new Date(process.env.BUILD_TIME)).toFormat('MM/dd/yyyy HH:mm')}`}
              {process.env.NODE_ENV && ` Node: (${process.env.NODE_ENV})`}
              {process.env.SERVICE_ENV && ` Service: (${process.env.SERVICE_ENV})`}
            </>)}
        </Typography_1.default>
      </FooterLinks>
      {!isAuthenticated && (<Button_1.default variant="contained" size="medium" onClick={() => { var _a; return (_a = window.Usersnap) === null || _a === void 0 ? void 0 : _a.logEvent('web_feedback_button_click'); }} sx={{
                position: 'fixed',
                height: 38,
                bottom: 0,
                right: 32,
                fontSize: 16,
                borderRadius: 0,
            }}>
          Feedback
        </Button_1.default>)}
    </Wrapper>);
};
exports.default = Footer;
